export default class QuestionnaireActiveButtonEntity {
  constructor(description) {
    this.description = description
    this.isVisible = false
    this.updatedAt = new Date()
  }

  init(description) {
    this.description = description
    this.updatedAt = new Date()
  }

  show() {
    this.isVisible = true
    this.updatedAt = new Date()
  }

  hide() {
    this.isVisible = false
    this.updatedAt = new Date()
  }
}
